import { type AlertProps, Box, Button, Flex, Tooltip } from '@shared/components';
import { useCallback } from 'react';

import { BaseAlert, QSetCheckPublishedButton } from '../../components';
import { QSetListModalAction, useQSetListModal } from '../../providers';

// NOTE: ReturnType is declared here to make sure severity is string literal type
function getAlertProps(
  selectedQSetCount: number,
  handleCheckDraft: () => void,
  handleCheckPublished: () => void,
): Partial<AlertProps> {
  const isQSetSelected = selectedQSetCount > 0;

  if (isQSetSelected) {
    return {
      children: `เลือก ${selectedQSetCount} รายการ`,
      severity: 'info',
      action: (
        <Flex sx={(theme) => ({ gap: theme.spacing(2) })}>
          <Tooltip
            title='กรุณาเลือกชุดข้อสอบอย่างน้อย 2 รายการ'
            disableHoverListener={selectedQSetCount > 1}
          >
            {/* NOTE: This Box is necessary for triggering tooltip display with a disabled element since tooltip doesn't support disabled element */}
            <Box>
              <Button
                disabled={selectedQSetCount <= 1}
                size='small'
                color='secondary'
                variant='outlined'
                onClick={handleCheckDraft}
              >
                Check Draft
              </Button>
            </Box>
          </Tooltip>
          <QSetCheckPublishedButton onClick={handleCheckPublished} />
        </Flex>
      ),
      icon: false,
    };
  }

  return {
    children: 'กรุณาเลือกชุดข้อสอบที่ต้องการ เพื่อตรวจสอบค่าความซ้ำ',
    severity: 'info',
    icon: undefined,
  };
}

export default function DraftQSetListBanner() {
  const { selectedQSetIds, setAction } = useQSetListModal();

  const handleCheckDraft = useCallback(() => {
    setAction(QSetListModalAction.CHECK_DUPLICATE);
  }, [setAction]);

  const handleCheckPublished = useCallback(() => {
    setAction(QSetListModalAction.CHECK_PUBLISHED);
  }, [setAction]);

  return (
    <Flex sx={{ padding: (theme) => theme.spacing(4), width: '100%' }}>
      <BaseAlert
        {...getAlertProps(selectedQSetIds.length, handleCheckDraft, handleCheckPublished)}
      />
    </Flex>
  );
}
